export function isBonlivaCareCostCenter(costCenterId: string): boolean {
  return [
    "600",
    "655",
    "657",
    "660",
    "662",
    "665",
    "642",
    "653",
    "666",
    "644",
    "630",
    "632",
    "634",
    "646"
  ].includes(costCenterId);
}

export function hasBonlivaCareCostCenter(costCenters: string[]): boolean {
  return costCenters?.some((id) => isBonlivaCareCostCenter(id));
}
